import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import email from './appData'
import settings from './settings'
import library from './library'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		settings,
		email,
		library,
	},
	state: {
		instances: [],
		instancesForUnsubscribe: [],
		instance: null,
		hives: [],
		loading: false,
		cats: [],
		pageButtons: [],
		uploadDialog: false,
		folders: [],
		files: {},
		currentFolder: '/',
		theApp: {},
		featureStates: {},
		step: '',
		fileStructure: [],
	},
	mutations: {
		SET_FILE_STRUCTURE(state, data) {
			state.fileStructure = data;
		},
		LOAD: (state, bool = !state.loading) => state.loading = bool,
		PAGE_BUTTONS(state, buttons) {
			state.pageButtons = buttons
		},
		CURRENT_STEP(state, data) {
			state.step = data
		},

		SET_APP(state, data) {
			state.theApp = data
		},
		SET_FEATURE_STATES(state, data) {
			state.featureStates = data
		},
		cancelUpload: (state) => {
			state.uploadDialog = false
		},
		uploadDialog: (state, folders) => {
			state.uploadDialog = true
			state.folders = folders
		},
		SET_INSTANCE: (state, data) => {
			state.instance = data
			state.cats = data.activeApps
		},
		SET_INSTANCES: (state, data) => {
			state.instances = data
		},
		SET_INSTANCES_FOR_UNSUBSCRIBE: (state, data) => {
			state.instancesForUnsubscribe = data
		}
	},
	getters: {

	},
	actions: {



	},
})
